import { useState, useRef, useEffect } from "react";
// import { Link } from "react-scroll";
import { Link } from "react-router-dom";
import "../assets/css/header.scss";
import { APP_LOGO, APP_PREFIX_PATH } from "../config/AppConfig";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const Header = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const dropdownRef = useRef();
  const navigate = useNavigate();
  const token = sessionStorage.getItem("token");

  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);
  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Check if user is logged in
  const isLoggedIn = !!sessionStorage.getItem("token");

  // Handlers
  const handleLoginClick = () => {
    navigate(`${APP_PREFIX_PATH}/login`);
  };

  const handleRegisterClick = () => {
    navigate(`${APP_PREFIX_PATH}/register`);
  };

  const handleProfileClick = () => {
    navigate(`${APP_PREFIX_PATH}/profile`);
  };

  // const handleLogoutClick = () => {
  //   sessionStorage.removeItem("token");
  //   navigate(`${APP_PREFIX_PATH}/`);
  // };

  const handleLogoutClick = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Logout",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        sessionStorage.removeItem("token");
        Swal.fire({
          title: "Logged out!",
          text: "You have been logged out successfully.",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });
        navigate(`/${APP_PREFIX_PATH}/`);
      }
    });
  };

  return (
    <header id="header" className="header-section">
      <div className="container">
        <nav className="navbar">
          {/* Logo */}
          <a href="/" className="navbar-brand">
            <img src={APP_LOGO} alt="TechXChange" />
          </a>

          {/* Mobile Toggle Button */}
          <button className="mobile-toggle" onClick={toggleMobileMenu}>
            {isMobileMenuOpen ? "✖" : "☰"}
          </button>

          {/* Menu + Dropdown */}
          <div className={`menu-wrap ${isMobileMenuOpen ? "open" : ""}`}>
            {/* <ul className="nav">
              <li>
                <Link
                  to={APP_PREFIX_PATH + "/"}
                  smooth
                  duration={500}
                  className="nav-link active"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to={`/${APP_PREFIX_PATH}/`}
                  smooth
                  duration={500}
                  className="nav-link"
                >
                  All Product
                </Link>
              </li>
              <li>
                <Link
                  to="Add Product"
                  smooth
                  duration={500}
                  className="nav-link"
                >
                  Add Product
                </Link>
              </li>
            </ul> */}
            <ul className="nav">
              <li>
                <Link
                  to={
                    token ? `/${APP_PREFIX_PATH}/` : `/${APP_PREFIX_PATH}/login`
                  }
                  className="nav-link active"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to={
                    token ? `/${APP_PREFIX_PATH}/` : `/${APP_PREFIX_PATH}/login`
                  }
                  className="nav-link"
                >
                  All Products
                </Link>
              </li>
              <li>
                <Link
                  to={
                    token ? `/${APP_PREFIX_PATH}/` : `/${APP_PREFIX_PATH}/login`
                  }
                  className="nav-link"
                >
                  Add Product
                </Link>
              </li>
            </ul>

            {/* Account Dropdown */}
            <div className="header-btn dropdown" ref={dropdownRef}>
              <button className="default-btn" onClick={toggleDropdown}>
                My Account ▾
              </button>
              {isDropdownOpen && (
                <div className="dropdown-menu">
                  {!isLoggedIn ? (
                    <>
                      <button
                        onClick={handleLoginClick}
                        className="dropdown-item"
                      >
                        Login
                      </button>
                      <button
                        onClick={handleRegisterClick}
                        className="dropdown-item"
                      >
                        Register
                      </button>
                    </>
                  ) : (
                    <>
                      {/* <button
                        onClick={handleProfileClick}
                        className="dropdown-item"
                      >
                        Profile
                      </button> */}
                      <button
                        onClick={handleLogoutClick}
                        className="dropdown-item"
                      >
                        Logout
                      </button>
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
